module.exports = __webpack_public_path__ + "static/media/regalo_theirs.ecc9a3ba.png";